import clsx from 'clsx';
import type { BanSuggestion } from '../../hooks/useBanAutocomplete';

interface BanDropdownProps {
  suggestions: BanSuggestion[];
  highlightedIdx: number;
  isLoading: boolean;
  onSelect: (s: BanSuggestion) => void;
}

export function BanDropdown({ suggestions, highlightedIdx, isLoading, onSelect }: BanDropdownProps) {
  return (
    <div className="absolute z-50 top-full left-0 right-0 mt-0.5 bg-dark-elevated border border-dark-border rounded-lg shadow-lg overflow-hidden">
      {isLoading && suggestions.length === 0 && (
        <div className="px-3 py-2 text-xs text-dark-text-muted">Searching…</div>
      )}
      {suggestions.map((s, i) => (
        <button
          key={i}
          type="button"
          onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); onSelect(s); }}
          className={clsx(
            'w-full text-left px-3 py-2 text-xs',
            i === highlightedIdx
              ? 'bg-primary-900/30 text-primary-400'
              : 'text-dark-text-secondary hover:bg-dark-border'
          )}
        >
          {s.display}
        </button>
      ))}
    </div>
  );
}
